import { render, staticRenderFns } from "./dropdownMenu.vue?vue&type=template&id=1a68d3f1"
import script from "./dropdownMenu.vue?vue&type=script&lang=js"
export * from "./dropdownMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports